//const
const SET_VERIFY_USER_DETAIL_USER = "verifyUserDetail/SET_USER"

//reducer
export const verifyUserDetail = (state = {
  selectedUser:null,
},action) => {
  switch (action.type) {
    case SET_VERIFY_USER_DETAIL_USER:
      return {
        ...state,
        selectedUser:action.data
      };
    default:
      return state
  }
};

export const setVerifyUserDetailUser = (data) => {
  return {
    type: SET_VERIFY_USER_DETAIL_USER,
    data: data
  }
};
